module.exports = __webpack_public_path__ + "media/reskin-images/icon--dollar-fc24c8d3.svg";